import * as React from "react";
export const FilterIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={50} height={50} viewBox="0 0 50 50" {...props}>
      <path
        fill="#6d7278"
        d="M19 26L19 41C19 41.4 19.2 41.7 19.5 41.9L29.5 47.9C29.6 48 29.8 48 30 48C30.2 48 30.3 48 30.5 47.9C30.8 47.7 31 47.4 31 47L31 26L19 26ZM46 2L4 2C3.4 2 3 2.4 3 3L3 6C3 6.3 3.1 6.5 3.3 6.7L19.3 23.7C19.5 23.9 19.8 24 20 24L30 24C30.3 24 30.5 23.9 30.7 23.7L46.7 6.7C46.9 6.5 47 6.3 47 6L47 3C47 2.4 46.6 2 46 2Z"
      />
    </svg>
  );
};
